// extracted by mini-css-extract-plugin
module.exports = {"dj-case":"case_dj-case__2r63U","dj-case-center":"case_dj-case-center__3HU42","dj-case-whole":"case_dj-case-whole__2f4Zy"};